import React, { useEffect } from 'react'
import { useState } from 'react'
import { Link } from 'react-router-dom'

const Footer = () => {

    const [socialMedia,setSocialMedia]=useState([]);
    useEffect(()=>{
        fetch("social.json")
        .then((res)=>res.json())
        .then((data)=>setSocialMedia(data))
    },[])

  return (
    <div className='py-20 bg-[#0E1629] border-t border-[#2A3343]'>
        <div className='container'>
            <div>
                <div className='flex  justify-center gap-2 mt-7'>
                    {socialMedia.map((social)=> <Link key={social.id} className='w-10 border-2 border-[#22d3ee] rounded-full' to={social.link} target='_blank'><img src={social.icon} alt={social.title} /></Link>)}
                </div>
                <p className='text-center mt-10 text-white'>© Copyright 2022 | Ridoy Sharif</p>
            </div>
        </div>
    </div>
  )
}

export default Footer